import { ILocation } from '../../../types/location';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getLocations } from '../../../actions/geoSuggest';
import { debounce } from 'throttle-debounce';

export const MIN_SEARCH_LENGTH = 3;

export interface IUseLocationSuggest {
  togglePopup(value: boolean): void;
}
export const useLocationSuggest = ({ togglePopup }: IUseLocationSuggest) => {
  const dispatch = useDispatch();

  const [suggest, setSuggest] = useState<ILocation[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  const getLocationSuggest = useCallback(
    async (value: string) => {
      if (value.length < MIN_SEARCH_LENGTH) {
        return;
      }

      setIsFetching(true);

      const locations = await dispatch(getLocations({ request: value }) as unknown as Promise<ILocation[]>);

      togglePopup(true);
      setSuggest(locations);
      setIsFetching(false);
    },
    [dispatch, togglePopup],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getLocationSuggestDebounced = useCallback(debounce(200, getLocationSuggest), [getLocationSuggest]);

  return {
    suggest,
    getLocationSuggest: getLocationSuggestDebounced,
    isFetching,
  };
};
